/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_AwardService_Dtos_VestingTemplate_VestingTemplateBulkExportDto } from '../models/Wealthlane_AwardService_Dtos_VestingTemplate_VestingTemplateBulkExportDto';
import type { Wealthlane_AwardService_Dtos_VestingTemplate_VestingTemplateBulkSelectDeselectDto } from '../models/Wealthlane_AwardService_Dtos_VestingTemplate_VestingTemplateBulkSelectDeselectDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class VestingTemplateFilterService {

    /**
     * @param requestBody 
     * @returns Wealthlane_AwardService_Dtos_VestingTemplate_VestingTemplateBulkExportDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppVestingTemplateFilterBulkExportVestingTemplateByFilter(
requestBody?: Wealthlane_AwardService_Dtos_VestingTemplate_VestingTemplateBulkSelectDeselectDto,
): CancelablePromise<Wealthlane_AwardService_Dtos_VestingTemplate_VestingTemplateBulkExportDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/vesting-template-filter/bulk-export-vesting-template-by-filter',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
